import { CspDirectives } from '@phoenix/core/frontend/shared/domain/security/csp.model';

const stihlLocalisedDomains = ['bg', 'ca', 'pl', 'it', 'hu', 'ch', 'rs', 'es', 'nl']
  .reduce((prev, curr) => `${prev} https://*.stihl.${curr}`, '')
  .trimStart();

const appDomains = process.env.NEXT_PUBLIC_APP_DOMAINS;
const googleMapsDomains = ['https://maps.googleapis.com', 'https://maps.gstatic.com'].join(' ');
const fontDomains = ['data:', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].join(' ');

export const imageDomains = [
  'https://images.ctfassets.net',
  'https://stage.stihl.de',
  'https://www.stihl.de',
  'https://static.stihl.com',
  'https://datastorcproductsint.blob.core.windows.net',
  'https://datastorcproductsprd.blob.core.windows.net',
  'https://dam.stihl.cloud',
  'https://i.ytimg.com',
  stihlLocalisedDomains,
  'blob:',
];

export const dashboardCspDirectives: CspDirectives = {
  connectSrc: `${googleMapsDomains} ${appDomains} https://cdn.contentful.com`,
  imgSrc: `data: ${imageDomains.join(' ')} ${googleMapsDomains}`,
  scriptSrc: googleMapsDomains,
  styleSrc: fontDomains,
  fontSrc: fontDomains,
};
